module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Menu_16"],"path":[{"$":{"d":"M14,5H2V3H14Zm0,2H2V9H14Zm0,4H2v2H14Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Menu_16.svg
// module id = 67Ix
// module chunks = 1